<template>
  <span>
    <v-fade-transition mode="out-in">
      <v-card class="elevation-3 hidden-sm-and-down" style="width: 85%">
        <router-link :to="'/product/'+ product.slug">
          <div class="ribbon1" v-if="product.product_key == 'discount'"><span>{{ $t('ribbon_discount') }}</span></div>
          <div class="ribbon2" v-if="product.product_key == 'new'"><span>{{ $t('ribbon_new') }}</span></div>
          <div class="ribbon3" v-if="product.product_key == '123'"><span>{{ $t('ribbon_sold') }}</span></div>
          <div class="ribbon4" v-if="product.product_key == 'giveaway'"><span>{{ $t('ribbon_popular') }}</span></div>
          <div class="ribbon5" v-if="product.product_key == '234'"><span>{{ $t('ribbon_review') }}</span></div>
          <div class="ribbon6" v-if="product.product_key == '678'"><span>{{ $t('ribbon_rating') }}</span></div>
          <v-img  height="170" :src="getProductImage(product.productImages)" :lazy-src="getProductImage(product.productImages)">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-card-title style="height: 50px; font-size: 20px; word-break: normal; line-height: 1.2">
            {{product.name | capitalize}}
          </v-card-title>
        </router-link>
        <v-card-text>
          <v-layout align-center>
            <v-rating :value="4.5" color="amber" half-increments dense size="16" readonly></v-rating>
            <span class="grey--text ml-1 font-weight-bold">4.5 (413)</span>
          </v-layout>
          <router-link :to="'/client/'+ product.client_slug" class="vail">
            {{product.client | capitalize}}
          </router-link>
          <div class="label">
            {{product.price | currency('K ') }}|
            <v-tooltip top v-if="userIsAuthenticated">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <span v-if="product.layby_price">
                    <v-avatar size="17">
                      <span class="white--text" style="font-size: 16px">
                        <v-icon>mdi-calendar-clock</v-icon>
                      </span>
                    </v-avatar> |
                  </span> 
                </span>
              </template>
              <span>{{$t('layby_on')}}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="userIsAuthenticated">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-btn color="black" dark x-small rounded @click="addToProductCart">
                    <v-icon small>mdi-cart</v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{ $t('product_cart') }}</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-btn 
                    color="grey" dark x-small rounded 
                    v-if="$route.name == 'home'" @click="goToSignIn">
                    <v-icon small>mdi-cart</v-icon>
                  </v-btn>
                  <v-btn 
                  color="grey" dark x-small rounded 
                  v-else @click="goToSignInI">
                    <v-icon small>mdi-cart</v-icon>
                  </v-btn>
                </span>
              </template>
              <span>{{$t('product_signin')}}</span>
            </v-tooltip>
          </div>
        </v-card-text>
      </v-card>
    </v-fade-transition>
    <v-fade-transition mode="out-in">
      <v-card class="elevation-3 hidden-md-and-up"  style="width: 85%">
        <router-link :to="'/product/'+ product.slug">
          <div class="ribbon1" v-if="product.product_key == 'discount'"><span>{{ $t('ribbon_discount') }}</span></div>
          <div class="ribbon2" v-if="product.product_key == 'new'"><span>{{ $t('ribbon_new') }}</span></div>
          <div class="ribbon3" v-if="product.product_key == '123'"><span>{{ $t('ribbon_sold') }}</span></div>
          <div class="ribbon4" v-if="product.product_key == 'giveaway'"><span>{{ $t('ribbon_popular') }}</span></div>
          <div class="ribbon5" v-if="product.product_key == '234'"><span>{{ $t('ribbon_review') }}</span></div>
          <div class="ribbon6" v-if="product.product_key == '678'"><span>{{ $t('ribbon_rating') }}</span></div>
          <v-img  height="130" contain
            :src="getProductImage(product.productImages)"
            :lazy-src="getProductImage(product.productImages)">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-card-title style="height: 45px; font-size: 15px; word-break: normal; line-height: 1.0" class="subtitle-1 font-weight-bold">
            {{product.name | capitalize}}
          </v-card-title>
        </router-link>
        <v-rating :value="3.5" color="black" half-increments dense size="14" readonly class="pad"></v-rating>
        <div class="font-weight-bold" style="height: 40px; line-height: 1.0;">
          <router-link :to="'/client/'+ product.client_slug" class="vail pad">{{product.client | capitalize}}</router-link>
        </div>
        <div class="label pad" style="min-height: 50px;">{{product.price | currency('K ')}}<br>
          <v-tooltip top v-if="userIsAuthenticated">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <span v-if="product.layby_price">
                  <v-avatar size="17">
                    <span class="white--text" style="font-size: 16px">
                      <v-icon>mdi-calendar-clock</v-icon>
                    </span>
                  </v-avatar> |
                </span> 
              </span>
            </template>
            <span>{{$t('layby_on')}}</span>
          </v-tooltip> 
          <v-tooltip bottom v-if="userIsAuthenticated">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn color="black" dark x-small rounded @click="addToProductCart">
                  <v-icon x-small>mdi-cart</v-icon>
                </v-btn>
              </span>
            </template>
            <span>{{ $t('product_cart') }}</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn color="grey" dark x-small rounded @click="goToSignIn">
                  <v-icon x-small>mdi-cart</v-icon>
                </v-btn>
              </span>
            </template>
            <span>{{ $t('product_signin') }}</span>
          </v-tooltip>
        </div>
      </v-card>
    </v-fade-transition>
  </span>
</template>

<script>
	import {fb,db,auth} from '@/firebase'
  export default {
    props: {
      product: {
        required: true,
        type: Object
      }
    },
    data: () => ({
      quantityValue: 1
    }),
    created(){
      auth.onAuthStateChanged(userauth => {
        if(userauth){
          this.userauth = userauth;
        } else {
          this.userauth = null;
        }
      })
    },
    methods: {
      getProductImage(productImages){
        return productImages[0]
      },

      goToSignIn(){
        this.$router.push('/signin')
      },

      goToSignInI(){
        this.$router.push({ 
          name: 'signin_alt', 
          params: { slug: this.product.slug }
        })
      },

      addToProductCart(){
        this.total = ((this.quantityValue)*(this.product.price))
        db.collection('cartitems').add({
            product_name: this.product.name,
            product_image: this.product.productImages,
            product_price: this.product.price,
            client_name: this.product.client,
            client_town: this.product.town_code,
            product_quantity: this.quantityValue,
            product_total: this.total,
            product_id: this.product.id,
            user: fb.auth().currentUser.uid
        }).then(() => {
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'product added to cart'
        })
        }).catch(err => {
            console.log(err);
        })
        /* eslint-enable */
      }
    },

    computed: {
      userIsAuthenticated () {
        return this.userauth !== null && this.userauth !== undefined
      }
    }
  }
</script>

<style type="text/css" scoped>
  .pad {
    padding-left: 5px;
  }
  .vail {
    height: 30px;
    font-size: 15px;
    word-break: normal;
    line-height: 1.0
  }
</style>
